'use client';
import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';
import { useTranslations } from '@/i18n/useTranslations';

import Link from 'next/link';

import button from '@/styles/button.module.sass';
import text from '@/styles/text.module.sass';
import divs from '@/styles/divs.module.sass';

export default function PageNotFound() {
  const { t, tbr } = useTranslations('PageNotFound');
  const router = useRouter();

  const pathname = usePathname();
  const [adress, setAdress] = useState(pathname.slice(1));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    router.push(`/${adress}`);
  };

  return (
    <form className={`${divs.flexCl24} ${divs.center}`} onSubmit={handleSubmit}>
      <div className={divs.center}>
        <h1 className={text.h1}>404</h1>
        <p className={text.p}>{tbr('description')}</p>
      </div>
      <div className={divs.flexCl4}>
        <Link className={button.accent} href="/">
          {tbr('home')}
        </Link>
        <input
          className={button.input}
          type="text"
          value={adress}
          onChange={(e) => setAdress(e.target.value)}
          placeholder={t('existingRoom')}
        />
      </div>
    </form>
  );
}
